import { z } from "zod";

export const UserGroupSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
});

export type UserGroup = z.infer<typeof UserGroupSchema>;
